import React, { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";

const WALLET_LABELS = {
  funding: "Funding Wallet",
  spot: "Spot Wallet",
  main: "Main Wallet",
  p2p: "P2P Wallet",
  futures: "Futures Wallet",
  swap: "Swap Wallet",
  earning: "Earning Wallet",
  margin: "Isolated Margin Wallet",
  cross_margin: "Cross Margin Wallet",
  options: "Options Wallet",
  staking: "Staking Wallet",
};

// NOTE: Use Remix icons instead of white SVGs so icons stay visible
// on the mobile sidebar (which has a white background).
const WALLET_ICON_CLASS = {
  spot: "ri-wallet-3-line",
  main: "ri-safe-2-line",
  p2p: "ri-team-line",
  futures: "ri-line-chart-line",
  swap: "ri-swap-2-line",
  earning: "ri-hand-coin-line",
  margin: "ri-funds-line",
  cross_margin: "ri-swap-box-line",
  options: "ri-stock-line",
  staking: "ri-coins-line",
};

function getActiveWalletType(pathname) {
  const m = pathname.match(/\/user_profile\/wallet\/([^/]+)/);
  return m?.[1] || "";
}

function isCrossMarginActive(pathname) {
  return pathname.includes("/user_profile/cross_margin");
}

export default function WalletSidebar({ toggleContent }) {
  const location = useLocation();
  const active = useMemo(() => getActiveWalletType(location.pathname), [location.pathname]);
  const crossActive = useMemo(() => isCrossMarginActive(location.pathname), [location.pathname]);
  const stakingActive = useMemo(() => location.pathname.includes("/user_profile/staking"), [location.pathname]);

  const items = useMemo(
    () => [
      // { id: "funding", label: WALLET_LABELS.funding, iconClass: WALLET_ICON_CLASS.funding },
      { id: "spot", label: WALLET_LABELS.spot, iconClass: WALLET_ICON_CLASS.spot },
      { id: "main", label: WALLET_LABELS.main, iconClass: WALLET_ICON_CLASS.main },
      { id: "margin", label: WALLET_LABELS.margin, iconClass: WALLET_ICON_CLASS.margin },
      { id: "cross_margin", label: WALLET_LABELS.cross_margin, iconClass: WALLET_ICON_CLASS.cross_margin },
      // { id: "p2p", label: WALLET_LABELS.p2p, iconClass: WALLET_ICON_CLASS.p2p },
      { id: "futures", label: WALLET_LABELS.futures, iconClass: WALLET_ICON_CLASS.futures },
      { id: "options", label: WALLET_LABELS.options, iconClass: WALLET_ICON_CLASS.options },
      { id: "staking", label: WALLET_LABELS.staking, iconClass: WALLET_ICON_CLASS.staking },
      // { id: "swap", label: WALLET_LABELS.swap, iconClass: WALLET_ICON_CLASS.swap },
      { id: "earning", label: WALLET_LABELS.earning, iconClass: WALLET_ICON_CLASS.earning },
    ],
    []
  );

  const liActive = (id) => {
    if (id === "staking") return stakingActive ? "active mb-1" : "mb-1";
    return active === id ? "active mb-1" : "mb-1";
  };

  const walletLinkFor = (id) =>
    id === "staking" ? "/user_profile/staking" : `/user_profile/wallet/${id}`;

  return (
    <ul className="list-unstyled ps-0 navi_sidebar dashboard-sidebar-root wallet-sidebar-root">
      <li className={!active && !stakingActive ? "active mb-1" : "mb-1"} onClick={() => toggleContent?.("Overview")}>
        <Link to="/user_profile/asset_overview">
          <i className="ri-home-4-line navi_sidebar_icon" aria-hidden="true" />
          <div className="dashboard_menu_hd">Overview</div>
        </Link>
      </li>



      {items.map((it) => (
        <li key={it.id} className={liActive(it.id)} onClick={() => toggleContent?.(it.label)}>
          <Link to={walletLinkFor(it.id)} className="d-flex align-items-center gap-2">
            <i className={`${it.iconClass} navi_sidebar_icon`} aria-hidden="true" />
            <div className="dashboard_menu_hd">{it.label}</div>
          </Link>
        </li>
      ))}

      {/* <li className={crossActive ? "active mb-1" : "mb-1"} onClick={() => toggleContent?.("Cross Margin")}>
        <Link to="/user_profile/cross_margin" className="d-flex align-items-center gap-2">
          <i className="ri-swap-box-line navi_sidebar_icon" aria-hidden="true" />
          <div className="dashboard_menu_hd">Cross Margin Wallet</div>
        </Link>
      </li> */}
    </ul>
  );
}

